import React, { useState } from 'react';
import MainContext from './MainContext';
import { getSuperAdmin, signup, login, forgotpassowrd } from './contextPages/AuthContexts';
import {
  fetchAOwner,
  createOwner,
  updateOwnerSubscription,
  getAllOwners,
  deleteOwner,
  changeStatus,
} from './contextPages/OwnerContexts';
import { fetchAllClients, createClient, deleteClient } from './contextPages/ClientContexts';
import {
  fetchAllAppointments,
  createAppointment,
  deleteAppointment,
} from './contextPages/AppointmentContexts';
import { fetchAllStaffs, createStaff, deleteStaff } from './contextPages/StaffContexts';
import {
  fetchAllBranch,
  createBranch,
  deleteBranch,
  updateBranchSubscription,
  getBranch,
  updateBranchStatus,
} from './contextPages/BranchContexts';
import {
  getAllRequests,
  updateRequest,
  fetchAllSubscription,
  deleteSubscription,
  createSubscription,
} from './contextPages/SubscriptionsContexts';
import { fetchAllRequest } from './contextPages/AllRequestContexts';
import{fetchAllBillingAndMsgStatus, fetchtotalbillamount,fetchexpiringbranch, fetchLatestSubscriptionUpdateBranch} from './contextPages/superadminReportsContexts'
const MainState = (props) => {
  const [superAdminId, setSuperAdminId] = useState(null);
  const [superAdminData, setSuperAdminData] = useState({});
  const [showMessage, setShowMessage] = useState({});

  return (
    <>
      <MainContext.Provider
        value={{
          superAdminId,
          setSuperAdminId,

          superAdminData,
          setSuperAdminData,

          showMessage,
          setShowMessage,

          fetchAllBranch,
          createBranch,
          deleteBranch,
          updateBranchSubscription,
          getBranch,
          updateBranchStatus,

          fetchAllStaffs,
          createStaff,
          deleteStaff,

          fetchAllAppointments,
          createAppointment,
          deleteAppointment,

          fetchAllClients,
          createClient,
          deleteClient,

          signup,
          login,
          forgotpassowrd,
          getSuperAdmin,

          fetchAOwner,
          getAllOwners,
          deleteOwner,
          createOwner,
          updateOwnerSubscription,
          changeStatus,

          getAllRequests,
          updateRequest,
          fetchAllSubscription,
          deleteSubscription,
          createSubscription,

          fetchAllRequest,

          //new superadmin apis
          fetchAllBillingAndMsgStatus,
          fetchtotalbillamount,
          fetchexpiringbranch,
          fetchLatestSubscriptionUpdateBranch,
        }}
      >
        {props.children}
      </MainContext.Provider>
    </>
  );
};

export default MainState;
